import React from "react";
import { Button } from "react-bootstrap";
import FileSaver from "file-saver";
import XLSX from "xlsx";
import {  Tooltip } from '@mui/material';
import authService from '../../../services/auth/auth.service';

const ContractorTableExportCSV = ({ grid, fileName, wscols, own_contractor_groups }) => {
  // ******** XLSX with object key as header *************
  // const fileType =
  //   "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  // const fileExtension = ".xlsx";

  // const exportToCSV = (csvData, fileName) => {
  //   const ws = XLSX.utils.json_to_sheet(csvData);
  //   const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  //   const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  //   const data = new Blob([excelBuffer], { type: fileType });
  //   FileSaver.saveAs(data, fileName + fileExtension);
  // };

  // ******** XLSX with new header *************
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const Heading = [
    {
      shortname: "Nazwa skrócona",
      name: "Nazwa",
      contactdate: "Data kontaktu",
      group_names: "Grupa",
      contractor_state: "Status",
      labels: "Etykiety",
      trade_name: "Branża",
      mail: "E-mail z NL",
      phone: "Telefon",
      contractor_newmstate: "NOWE-M",
      iis_name: "Spis inwestycji",
      classifications_array: "Klasyfikacja",
      unsub_eml: "Email rezygnacja z NL",
      unsub_tel: "elefon rezygnacja z NL",
      nip: "NIP",
      regon: "REGON",
      krs:"KRS",
      webpage: "Strona WWW",
      fax: "FAX",
      postcode: "Kod pocztowy",
      city:"Miasto",
      street:"Ulica",
      province:"Województwo",
      country:"Państwo",
      cor_postcode:"Kod pocztowy(adres kor.)",
      cor_city:"Miasto (adres kor.)",
      cor_street:"Ulica (adres kor.)",
      cor_province:"Województwo (adres kor.)",
      cor_country:"Państwo (adres kor.)",
      contractor_type: "Typ",
      gtu_array: "Grupa towarowa"


    }
  ];

  const exportToCSV = (grid, fileName, wscols) => {
    
    var csvData = grid.slickGrid.getSelectedRows().map((index)=> {
      var ownContractor = authService.isAdmin()
      var tmp = grid.slickGrid.getDataItem(index) 
      if (!ownContractor){
        if (own_contractor_groups &&  Array.isArray(own_contractor_groups) &&  own_contractor_groups.length>0){
           for (const group in tmp?.group_names_array){
             if (own_contractor_groups.includes(tmp?.group_names_array[group])){ 
              ownContractor = true;
                break;
             }  
           }
        }else{
          ownContractor = false;
        }
      }
      if (ownContractor){
        return grid.slickGrid.getDataItem(index)
      }else{
        return {}
      }
    
      });
    

    if (csvData.length>0){
     
      const ws = XLSX.utils.json_to_sheet(Heading, {
        header: [  "shortname",
          "name",
          "contactdate",
          "group_names",
          "contractor_state",
          "labels",
          "trade_name",
          "mail",
          "phone",
          "contractor_newmstate",
          "iis_name",
          "classifications_array",
          "unsub_eml",
          "unsub_tel",
          "nip",
          "regon",
          "krs",
          "webpage",
          "fax",
          "postcode",
          "city",
          "street",
          "province",
          "country",
          "cor_postcode",
          "cor_city",
          "cor_street",
          "cor_province",
          "cor_country",
          "contractor_type",
          "gtu_array"],
        skipHeader: true,
        origin: 0 //ok
      });
      ws["!cols"] = wscols;
      var colData = csvData.map(function(value,index) { return {
        "shortname" : value['shortname'],
        "name": value['name'],
        "contactdate": value['contactdate'],
        "group_names": value['group_names'],
        "contractor_state": value['contractor_state'],
        "labels": value['labels'],
        "trade_name": value['trade_name'],
        "mail": value['mail'],
        "phone": value['phone'],
        "contractor_newmstate": value['contractor_newmstate'],
        "iis_name": value['iis_name'],
        "classifications_array": value['classifications_array'],
        "unsub_eml": value['unsub_eml'],
        "unsub_tel": value['unsub_tel'],
        "nip": value['nip'],
        "regon": value['regon'],
        "krs": value['krs'],
        "webpage": value['webpage'],
        "fax": value['fax'],
        "postcode": value['postcode'],
        "city": value['city'],
        "street": value['street'],
        "province": value['province'],
        "country": value['country'],
        "cor_postcode": value['cor_postcode'],
        "cor_city": value['cor_city'],
        "cor_street": value['cor_street'],
        "cor_province": value['cor_province'],
        "cor_country": value['cor_country'],
        "contractor_type": value['contractor_type'],
        "gtu_array": value['gtu_array']
      }
      });
      XLSX.utils.sheet_add_json(ws, colData, {
        header: [  "shortname",
          "name",
          "contactdate",
          "group_names",
          "contractor_state",
          "labels",
          "trade_name",
          "mail",
          "phone",
          "contractor_newmstate",
          "iis_name",
          "classifications_array",
          "unsub_eml",
          "unsub_tel",
          "nip",
          "regon",
          "krs",
          "webpage",
          "fax",
          "postcode",
          "city",
          "street",
          "province",
          "country",
          "cor_postcode",
          "cor_city",
          "cor_street",
          "cor_province",
          "cor_country",
          "contractor_type",
          "gtu_array"],
        skipHeader: true,
        origin: -1 //ok
      });
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, fileName + fileExtension);
    }else{
      alert('Wybierz kontrahentów do eksportu!')
    }
  };

  return (

    <button className="btn btn-outline-secondary btn-sm mx-1" data-test="clear-sorting"
        onClick={e => exportToCSV(grid, fileName, wscols)}
    >
                <Tooltip title="Kontrahenci do XML">
                <i className="fas fa fa-file-excel-o nav-icon" />
                </Tooltip>
            </button>

  );
};

export default ContractorTableExportCSV;